<template>
    <section class="block">
        <slot name="block-left"></slot>
        <slot name="block-right"></slot>
    </section>
</template>

<script>
export default {
  name: "block"
};
</script>

<style lang="stylus">
@import '../style/block'
</style>





// WEBPACK FOOTER //
// src/components/Block.vue